module.exports = __webpack_public_path__ + "static/media/goods7.c6069d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods7.png
// module id = 1199
// module chunks = 0